<template>
    <div>
        <el-dialog class="peiso-modal kseries-container"
        :visible.sync="isOpen"
        :modal-append-to-body="false"
        :close-on-click-modal='false'
        :close-on-press-escape="false"
        width="550px"
        :before-close="handleClose"
        center>
            <div class="header-container">

                <span v-if="type == 'register'">Select Registers</span>
                <span v-else-if="type == 'food'">Select Foods</span>
                <span v-else-if="type == 'beverage'">Select Beverage</span>
                <span v-else-if="type == 'revenue_group'">Select Revenue Group</span>
                <span v-else-if="type == 'terminal'">Select Terminals</span>
            </div>

            <div class="body-container">
                <template v-if="loading">
                    <div class="loading-container">
                        <i class="el-icon-loading" style="font-size:20px;"></i>
                    </div>
                </template>
                <template v-else>

                    <template v-if="(registers.length > 0 || categories.length > 0) && type != 'revenue_group'">
                        <template v-if="type == 'register'">
                            <template v-if="registers.length">
                                <!-- <div class="header-container m-top-1rem m-bottom-1rem">
                                    <span>Select Registers</span>
                                </div> -->
                                <span v-if="validationMessage"  class="errortext m-bottom-1rem">{{validationMessage}}</span>
                                <div class="list-field-group">
                                    <div class="peiso-checkbox checkbox-select-all mb-1">
                                        <el-checkbox label="all" @change="checkedAllRegister" :key="`checkbox-beverage-1111`"  v-model="isCheckedRegister">{{ isCheckedRegister ? 'Unselect All' : 'Select All' }}</el-checkbox>
                                    </div>

                                    <el-checkbox-group v-model="selectedRegisters" class="peiso-checkbox" @change="handleSelected">

                                        <el-checkbox v-for="(item, i) in registers" :key="`checkbox-${item.id}`" :label="item">{{ item.name }}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </template>
                        </template>
                        <template v-if="type == 'food'">
                            <template v-if="categories.length">
                                <!-- <div class="header-container m-top-1rem m-bottom-1rem">
                                    <span>Select Foods</span>
                                </div> -->
                                <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
                                <div class="list-field-group">
                                    <div class="peiso-checkbox checkbox-select-all mb-1">
                                        <el-checkbox label="all" @change="checkedAllFood" :key="`checkbox-beverage-102`"  v-model="isCheckedFood">{{ isCheckedFood ? 'Unselect All' : 'Select All' }}</el-checkbox>
                                    </div>
                                    <el-checkbox-group v-model="checkedFood" class="peiso-checkbox" @change="handleSelectedFood">
                                        <el-checkbox v-for="(item, i) in categories" :key="`checkbox-food-${item.id}`" :label="item">{{ item.name }}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </template>
                        </template>

                        <template v-else-if="type == 'beverage'">
                            <template v-if="categories.length">
                                <!-- <div class="header-container m-top-1rem m-bottom-1rem">
                                    <span>Select Beverages</span>
                                </div> -->
                                <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
                                <div class="list-field-group">
                                    <div class="peiso-checkbox checkbox-select-all  mb-1">
                                        <el-checkbox label="all" :key="`checkbox-beverage-101`" @change="checkedAllBeverage" v-model="isCheckedBeverage">{{ isCheckedBeverage ? 'Unselect All' : 'Select All' }}</el-checkbox>
                                    </div>
                                    <el-checkbox-group v-model="checkedBeverage" class="peiso-checkbox" @change="handleSelectedBeverage">
                                        <el-checkbox v-for="(item, i) in categories" :key="`checkbox-beverage-${item.id}`"  :label="item">{{ item.name }}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </template>
                        </template>
                        <template v-else-if="type == 'terminal' && revenueType != 'tevalis'">
                            <template v-if="categories.length">
                                <!-- <div class="header-container m-top-1rem m-bottom-1rem">
                                    <span>Select Beverages</span>
                                </div> -->
                                <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
                                <div class="list-field-group">
                                    <div class="peiso-checkbox checkbox-select-all  mb-1">
                                        <el-checkbox label="all" :key="`checkbox-beverage-101`" @change="checkedAllTerminals" v-model="isCheckedTerminal">{{ isCheckedTerminal ? 'Unselect All' : 'Select All' }}</el-checkbox>
                                    </div>
                                    <el-checkbox-group v-model="checkedTerminal" class="peiso-checkbox" @change="handleTerminalSelect">
                                        <el-checkbox v-for="(item, i) in categories" :key="`checkbox-beverage-${i}`"  :label="item">{{ item.name }}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </template>
                        </template>
                        <template v-else-if="type == 'terminal' && revenueType == 'tevalis'">
                            <template v-if="categories.length">
                                <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
                                <div class="list-field-group">
                                    <div class="peiso-checkbox checkbox-select-all  mb-1">
                                        <el-checkbox label="all" :key="`checkbox-beverage-101`" @change="checkedAllTerminals" v-model="isCheckedTerminal">{{ isCheckedTerminal ? 'Unselect All' : 'Select All' }}</el-checkbox>
                                    </div>
                                    <el-checkbox-group v-model="checkedTerminal" class="peiso-checkbox" @change="handleTerminalSelect">
                                        <el-checkbox v-for="(item, i) in categories" :key="`checkbox-beverage-${i}`"  :label="item">{{ item }}</el-checkbox>
                                    </el-checkbox-group>
                                </div>

                                <div class="manual-terminal-list m-top-1rem d-flex gap-10 flex-column">
                                    <div>
                                        <span class="d-block m-bottom-10">Manual Entry Terminal:</span>
                                        <div class="d-flex align-items-center gap-10">
                                            <el-input v-model="manualTerminal" class="peiso-input-default"></el-input>
                                            <el-button class="save-terminal px-10" type="peiso-success" @click="saveManualTerminal()">Add</el-button>
                                        </div>
                                    </div>
                                    <div v-if="manualTerminals && manualTerminals.length" class="list-field-group d-flex flex-column gap-10">
                                        <div v-for="(item, i) in manualTerminals" :key="`terminal-${i}`" class="d-flex justify-content-between align-items-center gap-10">
                                            <div :class="`teminals-item teminals-item__${terminalStatus(item.transactionsState)}`">
                                              <svg v-if="terminalStatus(item.transactionsState) == 'success'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                              </svg>
                                              <svg v-else-if="terminalStatus(item.transactionsState) == 'warning'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
                                              </svg>
                                              <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
                                              </svg>
                                              <span>{{item.name}}</span>
                                            </div>
                                            <el-button class="remove-terminal px-10" type="peiso-danger" @click="removeManualTerminal(i)">Remove</el-button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </template>

                        <template>
                            <div class="d-flex gap-10 m-top-1rem">
                                <el-button type="peiso-default" class="w-100" @click="handleClose">Cancel</el-button>
                                <el-button v-if="!isLoading" type="peiso-primary-pink" class="w-100" @click="submit">Save</el-button>
                                <el-button v-else type="peiso-primary-pink" class="w-100"><i class="el-icon-loading" style="font-size:20px;"></i> Saving...</el-button>

                            </div>

                        </template>
                    </template>

                    <template v-else-if="type == 'revenue_group'">
                        <span v-if="validationMessage" class="errortext m-bottom-1rem">{{validationMessage}}</span>
                        <div class="list-field-group">

                            <el-checkbox-group :value="checkedRevenueGroup" class="peiso-checkbox">
                                <el-checkbox v-for="(item, i) in revenues"  @change="handleSelectedRevenue(item)" :key="`checkbox-revenue-${i}`" :label="item">{{ item }}</el-checkbox>
                            </el-checkbox-group>
                        </div>

                        <div class="d-flex gap-10 m-top-1rem">
                            <el-button type="peiso-default" class="w-100" @click="handleClose">Cancel</el-button>
                                <el-button v-if="!isLoading" type="peiso-primary-pink" class="w-100" @click="submit">Save</el-button>
                                <el-button v-else type="peiso-primary-pink" class="w-100"><i class="el-icon-loading" style="font-size:20px;"></i> Saving...</el-button>
                        </div>
                    </template>
                    <template v-else>
                        <div class="empty-container">
                            <h2>No data please relink revenue integration</h2>
                        </div>
                        <template>
                            <div class="d-flex gap-10 m-top-1rem">
                                <el-button type="peiso-default" class="w-100" @click="handleClose">Cancel</el-button>
                            </div>

                        </template>
                    </template>
                </template>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from "../../api/dashboard";
import utils from '../../utils/utils'
 export default  {
    props: ['open', 'type', 'isPro', 'revenueType'],
    data () {
        return {
            isOpen: false,
            categories: [],
            validationMessage: '',
            checkedFood: [],
            checkedBeverage: [],
            checkedRegisters: [],
            checkedTerminal: [],
            selectedRegisters: [],
            registers: [],
            isCheckedFood: false,
            isCheckedBeverage: false,
            isCheckedRegister: false,
            isCheckedTerminal: false,
            venueId: null,
            loading: false,
            checkedRevenueGroup: ['both'],
            revenueGroupId: 'both',
            revenues: [
                'both',
                'food',
                'beverage'
            ],
            isLoading: false,
            manualTerminals: [],
            manualTerminal: ''
        }
    },

    watch: {
        open(val) {
            if (val) {
                this.isOpen = this.open;
                this.fetchData();
            }
        },
    },
    methods: {
        handleClose() {
            this.isOpen = false
            this.$emit('close-modal')
        },
        handleSelected(e) {
            this.checkedRegisters = e
            this.isCheckedRegister = false;
        },
        terminalStatus (state) {
          switch (state) {
            case 'TRANSACTIONS_WITHIN_RANGE':
              return 'success'
            case 'HAS_TRANSACTIONS':
              return 'warning'
            default:
              return 'danger'
          }
        },

        checkedAllRegister() {
            // this.isCheckedRegister = !this.isCheckedRegister;

            if (!this.isCheckedRegister) {
                this.checkedRegisters = [];
                this.selectedRegisters = [];
            } else {
                this.selectedRegisters = this.registers;
                this.checkedRegisters = this.registers;
            }
        },
        checkedAllFood() {
            // this.isCheckedFood = !this.isCheckedFood;
            if (!this.isCheckedFood) {
                this.checkedFood = [];
            } else {
                this.checkedFood = this.categories;
            }
        },
        checkedAllBeverage() {
            if (!this.isCheckedBeverage) {
                this.checkedBeverage = [];
            } else {
                this.checkedBeverage = this.categories;
            }
        },
        checkedAllTerminals() {
            if (!this.isCheckedTerminal) {
                this.checkedTerminal = [];
            } else {
                this.checkedTerminal = this.categories;
            }
        },

        handleSelectedFood(e) {
            this.checkedFood = e
            this.isCheckedFood = this.categories.length == this.checkedFood.length ? true : false;
        },

        handleSelectedRevenue(item) {
            this.checkedRevenueGroup = [item]
            this.revenueGroupId = item;
        },

        handleSelectedBeverage(e) {
            this.checkedBeverage = e;
            this.isCheckedBeverage = this.categories.length == this.checkedBeverage.length ? true : false;
        },
        handleTerminalSelect(e) {
            this.checkedTerminal = e
            this.isCheckedTerminal = this.categories.length == this.checkedTerminal.length ? true : false
        },
        async submit () {
            if (this.type == 'register' && this.checkedRegisters.length <= 0) {
                this.validationMessage = 'Please select registers';
            } else if (this.type == 'food' && this.checkedFood.length <= 0) {
                this.validationMessage = 'Please select foods';
            } else if (this.type == 'beverage' && this.checkedBeverage.length <= 0) {
                this.validationMessage = 'Please select beverages';
            } else if (this.type == 'terminal' && this.checkedTerminal.length <= 0) {
                this.validationMessage = 'Please select terminals';
            } else {
                // Submit the update

                try {
                    this.isLoading = true
                    if (this.type == 'register') {

                        await api.saveVenueRegister({venueId: this.venueId, data: this.checkedRegisters});
                    } else if (this.type == 'food') {
                        if (this.revenueType == 'square' || this.revenueType == 'swiftpos') {
                            await api.saveVenueCategoriesNew(this.checkedFood, 'food', this.revenueType);
                        } else if (this.revenueType == 'oolio') {
                            await api.saveVenuePosCategories(this.checkedFood.map((n) => n.id), 'food', this.revenueType);
                        } else {
                            await api.saveVenueFood({venueId: this.venueId, data: this.checkedFood}, this.revenueType ? this.revenueType : 'oseries');
                        }
                    } else if (this.type == 'beverage') {
                        if (this.revenueType == 'square' || this.revenueType == 'swiftpos') {
                            await api.saveVenueCategoriesNew(this.checkedBeverage, 'beverage', this.revenueType);
                        } else if (this.revenueType == 'oolio') {
                            await api.saveVenuePosCategories(this.checkedBeverage.map((n) => n.id), 'beverage', this.revenueType);
                        } else {
                            await api.saveVenueBeverage({venueId: this.venueId, data: this.checkedBeverage}, this.revenueType ? this.revenueType : 'oseries');
                        }
                    } else if (this.type == 'revenue_group') {
                        if (this.revenueType == 'square' || this.revenueType == 'swiftpos') {
                            await api.saveVenueRevenueGroupNew({name: this.revenueGroupId}, this.revenueType);
                        } else if (this.revenueType=='oolio') {
                            await api.saveVenuePosRevenueGroup({name: this.revenueGroupId}, this.revenueType);
                        } else {
                            await api.saveVenueRevenueGroup({venueId: this.venueId, data: this.revenueGroupId}, this.revenueType ? this.revenueType : 'oseries');
                        }

                    } else if (this.type == 'terminal') {
                        var terminals = this.checkedTerminal
                        if (this.revenueType == 'tevalis') {
                            terminals = [...this.checkedTerminal, ...this.manualTerminals.map(item => item.name)]
                        }

                        if (this.revenueType == 'square') {
                            await api.saveVenueDevicesNew(terminals, this.revenueType)
                        } else if (this.revenueType == 'swiftpos') {
                            await api.saveVenueTerminalsNew(terminals, this.revenueType)
                        } else {
                            await api.saveVenueTerminal({venueId: this.venueId, data: terminals}, this.revenueType ? this.revenueType : 'oseries')
                        }
                    }
                    this.isLoading = false
                    this.$emit('fetch-data')

                    utils.alert2('', 'Successfully updated', 'success');

                    this.handleClose()

                } catch (error) {
                    utils.alert2('', 'Something went wrong, please contact administrator', 'error');
                }


            }
        },

        async fetchData () {
            this.loading = true;

            this.venueId = window.sessionStorage.getItem("subVenueId");

            const registerData = await api.getAllRegister({venueId: this.venueId});

            const selectedRegisterData = await api.getVenueRegisters({venueId: this.venueId});

            if (this.type == 'terminal') {
                let terminals = null;
                if (this.revenueType == 'square') {
                    terminals = await api.getSquareDeviceOptions();
                } else if (this.revenueType == 'swiftpos') {
                    terminals = await api.getVenueTerminalOptionsNew(this.revenueType)
                } else {
                    terminals = await api.getTerminalList({venueId: this.venueId}, this.revenueType)
                }

                if (terminals && terminals.data.code == 0) {
                    var checkedTerminals = null;
                    if (this.revenueType == 'square') {
                        checkedTerminals = await api.getSquareDevices()
                    } else if (this.revenueType == 'swiftpos') {
                        checkedTerminals = await api.getVenueTerminalsNew(this.revenueType)
                    } else {
                        checkedTerminals = await api.getVenueTerminalList({venueId: this.venueId}, this.revenueType)
                    }


                    if (checkedTerminals && checkedTerminals.data.code == 0) {
                        checkedTerminals = checkedTerminals.data.data

                        if (this.revenueType == 'swiftpos') {
                            this.categories = terminals.data.data.terminals
                        } else {
                            this.categories = terminals.data.data
                        }

                        this.checkedTerminal = this.categories.filter(item => checkedTerminals.find(data => data.id == item.id))
                        this.manualTerminals = []

                        checkedTerminals.forEach(res => {
                            if (!this.categories.find(data => data == res.name)) {
                                    this.manualTerminals.push(res)
                                }
                            });
                        this.isCheckedTerminal = this.categories.length == this.checkedTerminal.length ? true : false
                    }
                }

                this.loading = false;
                return
            }

            if (this.type != '') {
                let revenueGroupData = null;
                if (this.revenueType == 'square' || this.revenueType == 'swiftpos') {
                    revenueGroupData = await api.getVenueRevenueGroupNew(this.revenueType);
                    if (revenueGroupData && revenueGroupData.data.code == 0 && revenueGroupData.data.data) {
                        this.checkedRevenueGroup = [revenueGroupData.data.data.name]
                        this.revenueGroupId = revenueGroupData.data.data.name;
                    }
                } else if (this.revenueType=='oolio') {
                    revenueGroupData = await api.getVenuePosRevenueGroup(this.revenueType);
                    if (revenueGroupData && revenueGroupData.data.code == 0 && revenueGroupData.data.data) {
                        this.checkedRevenueGroup = [revenueGroupData.data.data.name]
                        this.revenueGroupId = revenueGroupData.data.data.name;
                    }
                } else {
                    revenueGroupData = await api.getVenueRevenueGroup({venueId: this.venueId}, this.revenueType ? this.revenueType : 'oseries');
                    if (revenueGroupData && revenueGroupData.data.code == 0 && revenueGroupData.data.data) {
                        this.checkedRevenueGroup = [revenueGroupData.data.data]
                        this.revenueGroupId = revenueGroupData.data.data;
                    }
                }



            }

            if (this.type == 'food' || this.type == 'beverage') {
                let productData = null;

                if (this.revenueType == 'square' || this.revenueType == 'swiftpos') {
                    productData = await api.getVenueCategoriesNew('options', this.revenueType);
                } else if (this.revenueType == 'oolio') {
                    productData = await api.getVenuePosCategories('', this.revenueType);
                } else {
                    productData = await api.getAllProducts({venueId: this.venueId}, this.revenueType ? this.revenueType : 'oseries');
                }


                if (productData && productData.data.code == 0) {
                    this.categories = productData.data.data;

                    if (this.type == 'food') {
                        let selectedFoodData = null;

                        if (this.revenueType == 'square' || this.revenueType == 'swiftpos') {
                            selectedFoodData = await api.getVenueCategoriesNew('food', this.revenueType);
                        } else if (this.revenueType == 'oolio') {
                            selectedFoodData = await api.getVenuePosCategories('food', this.revenueType);
                        } else {
                            selectedFoodData = await api.getVenueFood({venueId: this.venueId}, this.revenueType ? this.revenueType : 'oseries');
                        }

                        if (selectedFoodData && selectedFoodData.data.code == 0) {
                            const checkedFood = selectedFoodData.data.data;
                            if(this.revenueType == 'oolio'){
                              this.checkedFood = this.categories.filter(item =>  checkedFood.find(data => data == item.id));
                            } else{
                              this.checkedFood = this.categories.filter(item =>  checkedFood.find(data => data.id == item.id));
                            }
                            this.isCheckedFood = this.categories.length == this.checkedFood.length ? true : false;
                        }
                    }

                    if (this.type == 'beverage') {

                        let selectedBeverageData = null;

                        if (this.revenueType == 'square' || this.revenueType == 'swiftpos') {
                            selectedBeverageData = await api.getVenueCategoriesNew('beverage', this.revenueType);
                        } else if (this.revenueType == 'oolio') {
                            selectedBeverageData = await api.getVenuePosCategories('beverage', this.revenueType);
                        } else {
                            selectedBeverageData = await api.getVenueBeverage({venueId: this.venueId}, this.revenueType ? this.revenueType : 'oseries');
                        }

                        if (selectedBeverageData && selectedBeverageData.data.code == 0) {
                            const checkedBeverage = selectedBeverageData.data.data;
                            if(this.revenueType == 'oolio'){
                              this.checkedBeverage = this.categories.filter(item =>  checkedBeverage.find(data => data == item.id));
                            } else{
                              this.checkedBeverage = this.categories.filter(item =>  checkedBeverage.find(data => data.id == item.id));
                            }
                            this.isCheckedBeverage = this.categories.length == this.checkedBeverage.length ? true : false;

                        }
                    }
                }
            }

            if (this.type == 'register') {
                if (registerData.data.code == 0) {
                    this.registers = registerData.data.data;

                    if (selectedRegisterData.data.code == 0) {
                        const checkedRegisters = selectedRegisterData.data.data;

                        this.checkedRegisters = this.registers.filter(item => checkedRegisters.find(data => data.id == item.id));
                        this.selectedRegisters= this.registers.filter(item => checkedRegisters.find(data => data.id == item.id));
                    }
                }
            }

            this.loading = false;
        },

        saveManualTerminal() {
            if (this.manualTerminal) {
                this.manualTerminals.push({name: this.manualTerminal, transactionsState: "NO_TRANSACTIONS"})
                this.manualTerminal = ''
            } else {
              utils.alert2('', 'Please enter a terminal', 'error');
            }

        },

        removeManualTerminal(idx) {
            this.manualTerminals.splice(idx, 1)
        }
    },
    async mounted() {
        this.fetchData();
    }
 }
</script>

<style lang='scss'>
@import '../../../static/scss/colors.scss';
@import '../../../static/scss/fonts/fonts.scss';

    .teminals-item {
      display: flex;
      align-items: center;
      gap: 20px;

      &__success {
        svg {
          fill: #2ecc71;
        }
      }

      &__danger {
        svg {
          fill: #e74c3c;
        }
      }

      &__warning {
        svg {
          fill: #f39c12;
        }
      }
    }
    .loading-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px 0px;
        width: 100%;
    }
    .empty-container {
        margin: 40px 0px;
        width: 100%;
        h2 {
            font-size: 14px;
            text-align: center;
            color: #ffffff69;
        }

    }
    .mb-1 {
        margin-bottom: 10px;
    }
    .errortext {
        color: #ff4c30 !important;
        font-size: 13px !important;
        margin-bottom: 10px !important;
    }
    .checkbox-select-all {
        position: sticky;
        left: 0;
        top: -12px;
        width: 100%;
        z-index: 50;
        background-color: var(--background-color-3);
        padding-top: 10px;
    }
    .kseries-container {
        .el-button--peiso-default {
            > span {
                width: 100%;
            }
        }

        .el-dialog__headerbtn {
            display: none;
        }

        .list-grp-container {
            padding: 1rem;
        }

        .field-group {
            span {
                @include montserrat-font(14px, normal, 500, $white) {
                    margin-bottom: 10px;
                }
            }
        }

        .list-field-group {
            position: relative;
            min-height: 200px;
            max-height: 400px;
            overflow: hidden auto;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: #434968;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: #434968;
            }
            @include montserrat-font(14px, normal, 500, $white) {
                background-color: var(--background-color-3);
                padding: 10px;
            }
            .list-grp-container {

            }
        }

        .loading-container {
            position: absolute;
            left: 0px;
            top: 0px;
            height: 100%;
            background: var(--background-color-4);
            z-index: 10;
            border-radius: 10px;

            .loading-label-wrapper {
                padding: 2rem 2rem;
                box-shadow: 0 1px 3px rgba(0,0,0,.3);
                background-color: $gray2;
                z-index: 1000;
                @include montserrat-font(14px, normal, 500, $white);

                .loading {
                    font-size: 50px;
                }
            }
        }

        .manual-terminal-list {
            .save-terminal {
                height: 40px;
            }

            .remove-terminal {
                height: 30px;
                padding: 0px;
                display: flex;
                align-items: center;
                span {
                    font-size: 14px;
                }
            }

            .list-field-group {
                min-height: unset !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/modal/editSiteRegisterModal.vue